import { render, staticRenderFns } from "./LocationTrigger.vue?vue&type=template&id=3c1b0190&scoped=true"
import script from "./LocationTrigger.vue?vue&type=script&lang=js"
export * from "./LocationTrigger.vue?vue&type=script&lang=js"
import style0 from "./LocationTrigger.vue?vue&type=style&index=0&id=3c1b0190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b0190",
  null
  
)

export default component.exports